/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CustomField = {
    id: number;
    name: string;
    type: CustomField.type;
    required: boolean;
};
export namespace CustomField {
    export enum type {
        TEXT = 'text',
        TEXTAREA = 'textarea',
        DATE = 'date',
        CHECKBOX = 'checkbox',
        NUMBER = 'number',
    }
}

